import store from '../store.js'

export default {
    toDo: [
        {
            title: 'MOLECULE',
            path: '/molecule',
            icon: 'fa-atom fa-fw',
            color: 'bMolecule',
            allowed: {
                student: true
            }
        },
        {
            title: 'LIFE MAP',
            path: '/map-of-life',
            color: 'bMap',
            icon: 'fa-project-diagram fa-fw',
            allowed: {
                student: true
            }
        },
        {
            title: 'CAREER MAP',
            path: '/map-of-careers',
            color: 'bMapCareer',
            icon: 'fa-user-tie fa-fw'
        },
        {
            title: 'TOP 3',
            path: '/my-top3',
            color: 'bTop',
            icon: 'fa-fighter-jet fa-fw',
            allowed: {
                student: true
            }
        },
        {
            title: 'REPUTATION PLANNER',
            path: '/planner/p/own',
            color: 'bPlanner',
            icon: 'fa-plane-departure fa-fw',
            allowed: {
                student: true
            }
        }
    ],
    toLearn: [
        {
            title: '3 STEPS SKILLS PATH',
            path: '/videos',
            color: 'bVideos',
            icon: 'fa-video fa-fw'
        },
        {
            title: 'VIDEO LIBRARY',
            path: '/video-library',
            color: 'bMolecule',
            icon: 'fa-video fa-fw'
        },
        {
            title: 'INTERESTING STUFF',
            path: '/articles',
            color: 'bArticles',
            icon: 'fa-file-alt fa-fw'
        },
    ],
    personal: [
        {
            title: 'PROFILE',
            path: '/my-profile',
            icon: 'fa-user fa-fw',
            color: 'bProfile',
        },
        {
            title: 'AWARDS & BADGES',
            path: '/awards',
            color: 'bAwards',
            icon: 'fa-award fa-fw'
        },
        {
            title: 'CAPTAINS',
            path: '/captains',
            color: 'bCaptains',
            icon: 'fa-users fa-fw'
        },
        {
            title: 'ACCOUNT',
            path: '/account',
            icon: 'fa-user-circle fa-fw',
            color: 'accent',
        },
        {
            title: 'HOW TO',
            path: '/how-to',
            icon: 'fa-book fa-fw',
            color: 'primary',
        },
    ],
    ground: [
        {
            title: 'My Profile',
            path: '/my-profile',
            color: 'bProfile',
            icon: 'fa-grin-stars fa-fw',
            allowed: {
                student: true
            }
        },
        {
            title: 'My Profile',
            path: '/my-captain-profile',
            color: 'bProfile',
            icon: 'fa-grin-stars fa-fw',
            allowed: {
                captain: true
            }
        },
        {
            title: 'My Molecule',
            path: '/molecule',
            color: 'bMolecule',
            icon: 'fa-atom fa-fw',
            allowed: {
                student: true
            }
        },
        {
            title: 'My Life Map',
            path: '/map-of-life',
            color: 'bMap',
            icon: 'fa-project-diagram fa-fw',
            allowed: {
                student: true
            }
        },
        {
            title: 'My Top 3',
            path: '/my-top3',
            color: 'bTop',
            icon: 'fa-fighter-jet fa-fw',
            allowed: {
                student: true
            }
        },
        {
            title: 'My Career Map',
            path: '/map-of-careers',
            color: 'bMapCareer',
            icon: 'fa-user-tie fa-fw'
        },
        {
            title: 'My Reputation Planner',
            path: '/planner/p/own',
            color: 'bPlanner',
            icon: 'fa-plane-departure fa-fw',
            allowed: {
                student: true
            }
        },
        {
            title: 'My Team',
            path: '/my-team',
            color: 'bTeam',
            icon: 'fa-shapes fa-fw',
            allowed: {
                student: true
            }
        },
        {
            title: 'Captains',
            path: '/captains',
            color: 'bCaptains',
            icon: 'fa-users fa-fw'
        },
        {
            title: 'Interesting stuff',
            path: '/articles',
            color: 'bArticles',
            icon: 'fa-file-alt fa-fw'
        },
        {
            title: 'Online courses',
            path: '/videos',
            color: 'bVideos',
            icon: 'fa-video fa-fw'
        },
        {
            title: 'My group',
            path: '/my-group',
            color: 'bGroup',
            icon: 'fa-user-friends fa-fw',
            allowed: {
                student: true
            }
        },
        {
            title: 'Awards',
            path: '/awards',
            color: 'bAwards',
            icon: 'fa-award fa-fw'
        }
    ],
    admin: [
        {
            title: 'Users',
            path: '/admin-users',
            color: 'bProfile',
            icon: 'fa-users fa-fw',
            allowed: {
                master: true,
                director: true,
                captain: true
            }
        },
        {
            title: 'Interesting stuff',
            path: '/admin-articles',
            color: 'bArticles',
            icon: 'fa-file fa-fw',
            allowed: {
                master: true
            }
        },
        {
            title: 'Online courses',
            path: '/admin-videos',
            color: 'bVideos',
            icon: 'fa-file-video fa-fw',
            allowed: {
                master: true
            }
        },
        {
            title: 'Teams', 
            path: '/admin-teams',
            icon: 'fa-shapes fa-fw',
            color: 'bTeam',
            allowed: {
                master: true,
                director: true,
                captain: true
            }
        },
        {
            title: 'Groups', // ALL
            path: '/admin-groups',
            icon: 'fa-layer-group fa-fw',
            color: 'bGroup',
            allowed: {
                master: true
            }
        },
        {
            title: 'Center Groups', // CENTER
            path: '/admin-groups-center',
            icon: 'fa-layer-group fa-fw',
            color: 'bGroup',
            allowed: {
                director: true
            }
        },
        {
            title: 'Centers',
            path: '/admin-centers',
            icon: 'fa-school fa-fw',
            color: 'bCenter',
            allowed: {
                master: true
            }
        },
        {
            title: 'Sessions',
            path: '/admin-sessions',
            color: 'bSessions',
            icon: 'fa-file-alt fa-fw',
            allowed: {
                master: true
            }
        },
        {
            title: 'Payments',
            path: '/admin-payments',
            color: 'black',
            icon: 'fa-money-bill fa-fw',
            allowed: {
                master: true
            }
        }
    ],
    // personal: [
    //     {
    //         title: 'My account',
    //         path: '/account',
    //         icon: 'fa-user-circle fa-fw',
    //         color: 'accent',
    //     }
    // ]
}